import { render, staticRenderFns } from "./homeColumnTitle.vue?vue&type=template&id=1f23f19c&scoped=true&"
import script from "./homeColumnTitle.vue?vue&type=script&lang=js&"
export * from "./homeColumnTitle.vue?vue&type=script&lang=js&"
import style0 from "./homeColumnTitle.vue?vue&type=style&index=0&id=1f23f19c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f23f19c",
  null
  
)

export default component.exports